import { useTranslation } from "react-i18next";
import LinePlot from "../charts/LinePlot";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import NumericStatsPanel from "./NumericStatsPanel";

export default function Bloc0BlockSection({
  id,
  title,
  description,
  charts = null,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const soilStats = itemsByField["bloc0.temperatureSoil"]?.stats || null;
  const ambientStats = itemsByField["bloc0.temperatureAmbient"]?.stats || null;
  const rainStats = itemsByField["bloc0.daysSinceRain"]?.stats || null;
  const soilSeries = charts?.soilSeries || [];

  const soilBins = (soilStats?.bins || []).map((bin) => ({
    category: bin.label,
    count: bin.count,
  }));
  const ambientBins = (ambientStats?.bins || []).map((bin) => ({
    category: bin.label,
    count: bin.count,
  }));
  const rainBins = (rainStats?.bins || []).map((bin) => ({
    category: bin.label,
    count: bin.count,
  }));

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc0.loading", "Carregant estadístiques de bloc0…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <NumericStatsPanel
            title={t("dashboard.blocks.bloc0.soilTemp", "Temperatura del sòl")}
            stats={soilStats}
          />
          <NumericStatsPanel
            title={t("dashboard.blocks.bloc0.ambientTemp", "Temperatura ambient")}
            stats={ambientStats}
          />
          <NumericStatsPanel
            title={t("dashboard.blocks.bloc0.daysSinceRain", "Dies des de la pluja")}
            stats={rainStats}
          />
        </div>

        <div className="grid grid-cols-1 gap-4">
          <LinePlot
            title={t(
              "dashboard.blocks.bloc0.soilTempTrend",
              "Evolució temporal de la temperatura del sòl"
            )}
            points={soilSeries}
            yLabel="°C"
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc0.soilTempDistribution",
              "Distribució de temperatura del sòl"
            )}
            items={soilBins}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc0.ambientTempDistribution",
              "Distribució de temperatura ambient"
            )}
            items={ambientBins}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc0.daysSinceRainDistribution",
              "Distribució de dies des de la pluja"
            )}
            items={rainBins}
          />
        </div>
      </div>
    </DashboardBlockShell>
  );
}
